import moment from "moment";
import { t } from 'i18next'

function _getMinMaxValue(serieAnalisePU) {
	let min = 999999, max = 0;
	serieAnalisePU.forEach(s => {
	  s.data.forEach(v => {
		const f = parseFloat(v);
		if (f < min) min = f;
		if (f > max) max = f;
	  });
	});
	return { min: min - 0.5, max: max + 0.5 };
}
  
function computeChartData(cardData) {
	const catalog = cardData?.dataCatalog;
	if (!catalog?.tabela?.length) return null;
  
	const xCategories = [];
	const serieAnalisePU = [
	  { name: t('PU_day'),   data: [] },
	  { name: t('PU_AC'),    data: [] },
	  { name: t('goal_min'), data: [], type: "area" },
	  { name: t('goal_max'), data: [], type: "area" },
	  { name: t('goal_val'), data: [], type: "line" }
	];
  
	catalog.tabela.forEach((dia) => {
	  if (!parseFloat(dia.vr_pu_acumulado) || dia.qtde_comensais == 0) return;
	  const [d, m] = dia.data.split("/");
	  xCategories.push(`${d}/${m}`);
  
	  serieAnalisePU.find(s => s.name === t('PU_day')).data.push(dia.vr_pu_dia?.toFixed(5) ?? 0);
	  serieAnalisePU.find(s => s.name === t('PU_AC')).data.push(dia.vr_pu_acumulado?.toFixed(5) ?? 0);
	  serieAnalisePU.find(s => s.name === t('goal_max')).data.push(cardData.meta.VRL_CUSTO_MAX?.toFixed(5));
	  serieAnalisePU.find(s => s.name === t('goal_min')).data.push(cardData.meta.VLR_CUSTO_MIN?.toFixed(5));
	  serieAnalisePU.find(s => s.name === t('goal_val')).data.push(cardData.custo_pdr?.toFixed(5));
	});
  
	const yAxis = _getMinMaxValue(serieAnalisePU);
  
	const optionsAnalisePU = {
	  chart:  { id: "analise-pu" },
	  xaxis:  { categories: xCategories },
	  yaxis:  yAxis,
	  colors: ["#ffa500", "#21759B", "#fff", "#97f597", "#2d572c"],
	  fill:   { opacity: [1, 1, 1, 1], type: "solid" }
	};
  
	return { serieAnalisePU, optionsAnalisePU };
}

const hslToHex = (h, s, l) => {
	s /= 100;
	l /= 100;

	const k = n => (n + h / 30) % 12;
	const a = s * Math.min(l, 1 - l);
	const f = n =>
		Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));

	return `#${[f(0), f(8), f(4)]
		.map(x => x.toString(16).padStart(2, "0"))
		.join("")}`;
};

const getColorById = (id) => {
	const hue = (Number(id) * 137.508) % 360; // distribuição uniforme
	return hslToHex(hue, 65, 55);
};
  
let feedINGData = function (cardData) {
	const ingredientes = (cardData.dataCatalog && cardData.dataCatalog.ingredientes) || {};
	const ings = {};
	Object.values(ingredientes).forEach(ing => {
		if (!ing || !ing.id_ingrediente) return;

		ings[ing.id_ingrediente] = getColorById(ing.id_ingrediente);
	});

	return ings;
};

function buildDrilldown(dataCatalog, overrideResolver = null) {
	const tabela = dataCatalog?.tabela;
  
	if (!Array.isArray(tabela) || tabela.length === 0) return [];
  
	// Cache de acessos (performance)
	const pratosCatalog = dataCatalog.pratos || {};
	const gruposCatalog = dataCatalog.grupos || {};
	const ingredientesCatalog = dataCatalog.ingredientes || {};
	const tipoCorteCatalog = dataCatalog.tipocorte || {};
	const modoPreparoCatalog = dataCatalog.modopreparo || {};
  
	// Resolver de override: dado (coluna, dia) retorna { id_prato, perc_consumo } efetivos.
	// Se não houver override, usa os valores originais da coluna.
	const resolve = (coluna, dia) => {
	  if (typeof overrideResolver === 'function') {
		const o = overrideResolver(coluna, dia);
		if (o && (o.id_prato !== undefined || o.perc_consumo !== undefined)) {
		  return {
			id_prato: o.id_prato,
			perc_consumo: o.perc_consumo,
		  };
		}
	  }
	  return { id_prato: coluna.id_prato, perc_consumo: coluna.perc_consumo };
	};
  
	// =========================
	// 1. Soma total de comensais
	// =========================
	let comensdivtotal = 0;
  
	for (let i = 0; i < tabela.length; i++) {
	  const dia = tabela[i];
	  comensdivtotal += parseFloat(dia?.comensais_detalhe?.comensais_divisao) || 0;
	}
  
	// =========================
	// 2. Cálculo de custos
	// =========================
	const pratoCosts = {};
	const groupsCosts = {};
	const agrupsCosts = {};
	const pratoCount = {};   // qt_utilizado virtual por prato (considera override)
	const groupCount = {};   // qt_utilizado virtual por grupo
  
	for (let j = 0; j < tabela.length; j++) {
	  const dia = tabela[j];
  
	  if (!dia || dia.qtde_comensais === 0) continue;
  
	  const colunas = dia.colunas;
	  if (!Array.isArray(colunas)) continue;
  
	  for (let k = 0; k < colunas.length; k++) {
		const coluna = colunas[k];
		const eff = resolve(coluna, dia);
		if (!eff.id_prato) continue;
  
		const pratoInfo = pratosCatalog[eff.id_prato];
		if (!pratoInfo) continue;
  
		const grupoInfo = gruposCatalog[pratoInfo.id_grupo] || {};
  
		const comensaisPrato =
		  (parseFloat(dia.qtde_comensais) * (eff.perc_consumo || 0)) / 100;
  
		const custoPerCapita =
		  comensdivtotal > 0
			? (comensaisPrato * (pratoInfo.vlr_prato || 0)) / comensdivtotal
			: 0;
  
		// init seguro
		if (!pratoCosts[eff.id_prato]) pratoCosts[eff.id_prato] = 0;
		if (!groupsCosts[pratoInfo.id_grupo]) groupsCosts[pratoInfo.id_grupo] = 0;
		if (!agrupsCosts[grupoInfo.id_agrupamento_grupo])
		  agrupsCosts[grupoInfo.id_agrupamento_grupo] = 0;
		if (!pratoCount[eff.id_prato]) pratoCount[eff.id_prato] = 0;
		if (!groupCount[pratoInfo.id_grupo]) groupCount[pratoInfo.id_grupo] = 0;
  
		// acumulação
		pratoCosts[eff.id_prato] += custoPerCapita;
		groupsCosts[pratoInfo.id_grupo] += custoPerCapita;
		agrupsCosts[grupoInfo.id_agrupamento_grupo] += custoPerCapita;
		pratoCount[eff.id_prato] += 1;
		groupCount[pratoInfo.id_grupo] += 1;
	  }
	}
  
	// =========================
	// 3. Montagem de grupos
	// =========================
	const grupoMap = {};
  
	for (const prato of Object.values(pratosCatalog)) {
	  const idGrupo = prato.id_grupo;
	  if (idGrupo == null) continue;
  
	  const grupoInfo = gruposCatalog[idGrupo] || {};
  
	  const freq_p = dataCatalog.freq_pratos?.[prato.id_prato] || null;
  
	  const freqObj = freq_p
		? {
			qt_min_mes: freq_p.qt_min_mes,
			qt_max_mes: freq_p.qt_max_mes,
			qt_max_sem: freq_p.qt_max_sem,
		  }
		: { qt_min_mes: null, qt_max_mes: null, qt_max_sem: null };
  
	  const id_prato_sem_custo = !prato.vlr_prato || prato.vlr_prato <= 0;
  
	  // qt_utilizado efetivo: virtual se houver, senao o datacatalog!
	  const effQtUtilizado = (overrideResolver && pratoCount[prato.id_prato] !== undefined)
		? pratoCount[prato.id_prato]
		: (prato.qt_utilizado || 0);
  
	  const pratoObj = {
		id_prato: prato.id_prato,
		nm_prato: prato.nm_prato,
  
		nm_ingrediente_1:
		  ingredientesCatalog[prato.id_ingrediente_1]?.nm_ingrediente || null,
  
		nm_ingrediente_2:
		  ingredientesCatalog[prato.id_ingrediente_2]?.nm_ingrediente || null,
  
		nm_tipocorte:
		  tipoCorteCatalog[prato.id_tipocorte]?.nm_tipocorte || null,
  
		nm_modopreparo:
		  modoPreparoCatalog[prato.id_modopreparo]?.nm_modopreparo || null,
  
		freq: freqObj,
		qt_utilizado: effQtUtilizado,
  
		freqError:
		  (freqObj.qt_max_mes &&
			(effQtUtilizado) > freqObj.qt_max_mes) ||
		  (freqObj.qt_min_mes &&
			(effQtUtilizado) < freqObj.qt_min_mes),
  
		vlr_prato: prato.vlr_prato < 0 ? 0 : prato.vlr_prato,
		vlr_pu: pratoCosts[prato.id_prato] || 0,
  
		id_prato_sem_custo,
	  };
  
	  if (!grupoMap[idGrupo]) {
		const freq_g = dataCatalog.freq_grupos?.[idGrupo] || null;
  
		const freqGrupo = freq_g
		  ? {
			  qt_min_mes: freq_g.qt_min_mes,
			  qt_max_mes: freq_g.qt_max_mes,
			  qt_max_sem: freq_g.qt_max_sem,
			}
		  : { qt_min_mes: null, qt_max_mes: null, qt_max_sem: null };
  
		const effGroupQt = (overrideResolver && groupCount[idGrupo] !== undefined)
		  ? groupCount[idGrupo]
		  : (grupoInfo.qt_utilizado || 0);
  
		grupoMap[idGrupo] = {
		  id_grupo: idGrupo,
		  nm_grupo: grupoInfo.nm_grupo || idGrupo,
  
		  id_agrupamento_grupo: grupoInfo.id_agrupamento_grupo,
		  nm_agrupamento_grupo: grupoInfo.nm_agrupamento_grupo,
  
		  freq: freqGrupo,
		  qt_utilizado: effGroupQt,
  
		  freqError:
			(freqGrupo.qt_max_mes &&
			  (effGroupQt) > freqGrupo.qt_max_mes) ||
			(freqGrupo.qt_min_mes &&
			  (effGroupQt) < freqGrupo.qt_min_mes),
  
		  vlr_pu: groupsCosts[idGrupo] || 0,
  
		  id_sem_custo: false,
		  pratos: [],
  
		  utilizacao: {
			...(dataCatalog.utilizacao_grupo?.[idGrupo] || {}),
			nm_grupo: grupoInfo.nm_grupo || null,
		  },
		};
	  }
  
	  grupoMap[idGrupo].pratos.push(pratoObj);
  
	  if (id_prato_sem_custo) {
		grupoMap[idGrupo].id_sem_custo = true;
	  }
	}
  
	// =========================
	// 4. Agrupamento final
	// =========================
	const agrupMap = {};
  
	for (const grupo of Object.values(grupoMap)) {
	  const idAgrup = grupo.id_agrupamento_grupo;
	  if (idAgrup == null) continue;
  
	  if (!agrupMap[idAgrup]) {
		agrupMap[idAgrup] = {
		  id_agrupamento_grupo: idAgrup,
		  nm_agrupamento_grupo: grupo.nm_agrupamento_grupo,
  
		  freq: { qt_min_mes: 0, qt_max_mes: 0, qt_max_sem: 0 },
		  qt_utilizado: 0,
  
		  vlr_pu: agrupsCosts[idAgrup] || 0, // ✅ FIX
  
		  grupos: [],
		};
	  }
  
	  const agrup = agrupMap[idAgrup];
  
	  agrup.grupos.push(grupo);
	  agrup.qt_utilizado += grupo.qt_utilizado;
  
	  agrup.freq.qt_min_mes += grupo.freq.qt_min_mes || 0;
	  agrup.freq.qt_max_mes += grupo.freq.qt_max_mes || 0;
	  agrup.freq.qt_max_sem += grupo.freq.qt_max_sem || 0;
	}
  
	return Object.values(agrupMap);
  }

let generateCardExcell = function (dataCatalog, numero) {
	let trad = {
		Mon: t('subtitle2_monday'),
		Tue: t('subtitle2_tuesday'),
		Wed: t('subtitle2_wednesday'),
		Thu: t('subtitle2_thursday'),
		Fri: t('subtitle2_friday'),
		Sat: t('subtitle2_saturday'),
		Sun: t('subtitle2_sunday'),
	};
	const tabela = dataCatalog.tabela;
	const colunasInfo = dataCatalog.colunas;
	const pratosInfo = dataCatalog.pratos;
	
	if (!tabela?.length) return;
	
	if (!tabela[0]?.colunas?.length) return;
	const colunasDia = tabela[0].colunas;

	let data = [];
	let label = [{
			header: t('esteemed_diners'),
			key: "comens"
		},
		{
			header: t('date'),
			key: "data"
		},
	];
	for(const col of colunasDia){
		label.push({
			header: colunasInfo[col.id_coluna]?.nm_tipoprato || '--',
			key: 'seq' + col.id_coluna
		})
	}

	label = label.concat([{
			header: t('PU_day'),
			key: "pud"
		},
		{
			header: t('PU_ACCUMULATED'),
			key: "puac"
		},
	]);

	for (let i = 0; i < tabela.length; i++) {
		const dia = tabela[i];
		if(!dia) continue;
		let newData = {
			comens: dia.qtde_comensais,
			data: dia.data,
			pud: dia.vr_pu_dia != 0 ? parseFloat(dia.vr_pu_dia).toFixed(5) : '0',
			puac: dia.vr_pu_acumulado && dia.vr_pu_acumulado != 0 ? parseFloat(dia.vr_pu_acumulado).toFixed(5) : '0',
		};
		let dataMoment = moment(newData.data, "DD/MM/YYYY").locale("en");
		newData.data = dataMoment.format("DD") + " " + trad[dataMoment.format("ddd")];
		for(const coluna of dia.colunas){
			newData['seq' + coluna.id_coluna] = '--';
			if (coluna.id_prato) {
				newData['seq' + coluna.id_coluna] = parseFloat(coluna.perc_consumo).toFixed(2) + '%' + ' ' + (pratosInfo[coluna.id_prato]?.nm_prato || '--' );
				if (numero) {
					newData['seq' + coluna.id_coluna] = ((parseFloat(newData.comens) * parseFloat(coluna.perc_consumo)) / 100).toFixed(2) + ' ' + (pratosInfo[coluna.id_prato]?.nm_prato || '--' );
				}
			}
		};

		data.push(newData);
	}
	return {
		label,
		data
	};
};

let addIncidencia_tp_gp_prato = (dataFromOtm) => {
	const begining = performance.now()
	let formatMes = (DTMESCARD) => {
		return moment(DTMESCARD, 'DD/MM/YYYY HH:mi:ss').format('MM/YY');
	}

	let incidencias = dataFromOtm.incidencia_tp_gp_prato.data;

	let incidenciaTabela = [];

	let meses = [];
	let cdtippratovis = [];

	incidencias.forEach(i => {
		i.DTMESCARD = formatMes(i.DTMESCARD);

		if (meses.indexOf(i.DTMESCARD) < 0) {
			meses.push(i.DTMESCARD);
		}
	});

	incidencias.forEach(i => {
		if (cdtippratovis.indexOf(i.CDTIPOPRAT) < 0) {
			cdtippratovis.push(i.CDTIPOPRAT);

			let firstTpPrato = {
				ID: i.CDTIPOPRAT,
				NM: i.NMTIPOPRAT,
				isTPPRATO: true,
				pivo: i.CDTIPOPRAT,
				COD_TIP_PRATO: i.CDTIPOPRAT
			};
			let curTipoPratList = incidencias.filter(ift => i.CDTIPOPRAT == ift.CDTIPOPRAT);

			meses.forEach(m => {
				firstTpPrato['mediaPU'] = firstTpPrato['mediaPU'] ? firstTpPrato['mediaPU'] : 0;

				let curTipoPrat = curTipoPratList.find(ift => ift.DTMESCARD == m);
				if (curTipoPrat) {
					firstTpPrato['qtde' + m] = curTipoPrat.QTDE_TPPRAT;
					firstTpPrato['cons' + m] = curTipoPrat.CONSUMO_TPPRAT;
					firstTpPrato['pu' + m] = parseFloat(curTipoPrat.PU_TPPRAT).toFixed(5);
					firstTpPrato['mediaPU'] += parseFloat(parseFloat((parseFloat(curTipoPrat.PU_TPPRAT) / (meses.length))).toFixed(5));
				}
			});

			incidenciaTabela.push(firstTpPrato);

			let newGppratoList = [];

			meses.forEach(m => {
				curTipoPratList.filter(ift => ift.DTMESCARD == m).forEach(mi => {

					let curgpprato = newGppratoList.find(gp => gp.pivo == mi.NRGRUPOPRATOSERV && gp.COD_TIP_PRATO == firstTpPrato.COD_TIP_PRATO) || {
						//ID: mi.CDGRUPOPRATO,
						NM: mi.NMGRUPOPRATO,
						pivo: mi.NRGRUPOPRATOSERV,
						COD_TIP_PRATO: firstTpPrato.COD_TIP_PRATO
					};

					curgpprato['qtde' + m] = mi.QTDE_GPPRATO;
					curgpprato['cons' + m] = mi.CONSUMO_GPPRATO;
					curgpprato['pu' + m] = parseFloat(mi.PU_GPPRATO).toFixed(5);

					curgpprato['mediaPU'] = curgpprato['mediaPU'] ? curgpprato['mediaPU'] : 0;
					curgpprato['mediaPU'] += parseFloat((parseFloat((parseFloat(mi.PU_GPPRATO) / (meses.length))).toFixed(5)));


					curgpprato.plateList = curgpprato.plateList || [];
					let prato = {
						ID: `${i.CDFILAUXPRAT}${i.CDPRATO}`,
						NM: i.NMPRATO,
						pivo: `${i.CDFILAUXPRAT}${i.CDPRATO}`,
						COD_TIP_PRATO: i.CDTIPOPRAT,
						NRGRUPOPRATOSERV: i.NRGRUPOPRATOSERV,
					};

					prato['qtde' + m] = i.QTDE_PRATO;
					prato['cons' + m] = i.CONSUMO_PRATO;
					prato['pu' + m] = parseFloat(i.PU_PRATO).toFixed(5);

					prato['mediaPU'] = prato['mediaPU'] || 0;
					prato['mediaPU'] += parseFloat((parseFloat((parseFloat(i.PU_PRATO) / (meses.length))).toFixed(5)));

					if (i.NRGRUPOPRATOSERV == prato.NRGRUPOPRATOSERV) {
						if (!curgpprato.plateList.find(pl => pl.ID == prato.ID)) {
							curgpprato.plateList.push(prato);
						}
					}

					if (!newGppratoList.find(gp => gp.pivo == mi.NRGRUPOPRATOSERV /* && gp.pivo == firstTpPrato.COD_TIP_PRATO */ )) {
						newGppratoList.push(curgpprato);
					}


				});
			});

			incidenciaTabela[incidenciaTabela.length - 1].gplist = newGppratoList;
			newGppratoList = [];
		}
	});

	dataFromOtm.incidencia = {
		incidenciaTabela,
		meses
	};
	return dataFromOtm;
};

// https://stackoverflow.com/a/34890276
const _groupBy = function (xs, key) {
	return xs.reduce(function (rv, x) {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	}, {});
};

const _sum = (list, key) => list.reduce((a, b) => a[key] + b[key], 0);

const _average = (list, key) => (_sum(list, key) / list.length) || 0;

const _formatMes = (DTMESCARD) => {
	return moment(DTMESCARD, 'DD/MM/YYYY HH:mi:ss').format('MM/YY');
}
const _getPUAverageFromObject = (dataObject, lastMonthKey) => {
	const keysForAverage = Object.keys(dataObject).
	filter(k => k !== lastMonthKey && k.indexOf("pu") === 0)
	if (keysForAverage.length > 0) {
		const sum = keysForAverage.
		map(k => parseFloat(dataObject[k])).
		reduce((agg, c) => agg + c)

		return sum / keysForAverage.length
	} else {
		return null
	}
}

const _weightedAverage = (a, weight, b) => {
	return (a * weight + b) / (weight + 1)
}
addIncidencia_tp_gp_prato = (dataFromOtm) => {
	const {
		incidencia_tp_gp_prato
	} = dataFromOtm
	const begining = performance.now()
	const incidencias = incidencia_tp_gp_prato.data.map(i => ({
		...i,
		DTMESCARD: _formatMes(i.DTMESCARD)
	}))

	const meses = {}
	incidencias.forEach(i => {
		meses[i.DTMESCARD] = true
	})
	const monthsArray = Object.keys(meses)
	const lastMonth = monthsArray[monthsArray.length - 1]
	//console.log(meses, lastMonth)

	const incidenciasGroupedByPlateType = _groupBy(incidencias, 'CDTIPOPRAT');
	const incidenciasGroupedByPlateGroup = Object.values(incidenciasGroupedByPlateType).
	map(platesGroupedByPlateType => {
		return _groupBy(platesGroupedByPlateType, 'CDGRUPOPRATO')
	})


	const incidenciasGroupedByPlate = incidenciasGroupedByPlateGroup.
	map((plateGroups) => {
		const plateGroupsArray = Object.values(plateGroups);

		const firstPlateInType = plateGroupsArray[0][0]

		const plateTypeData = {
			ID: firstPlateInType.CDTIPOPRAT,
			pivo: firstPlateInType.CDTIPOPRAT,
			COD_TIP_PRATO: firstPlateInType.CDTIPOPRAT,
			NM: firstPlateInType.NMTIPOPRAT,
			isTPPRATO: true,
		}

		const gplist = plateGroupsArray.
		map(platesGroupedByPlateGroup => {

			const firstPlateData = platesGroupedByPlateGroup[0]
			const groupData = {
				NM: firstPlateData.NMGRUPOPRATO,
				pivo: firstPlateData.NRGRUPOPRATOSERV,
				COD_TIP_PRATO: firstPlateData.CDTIPOPRAT
			}
			const platesInGroup = {}
			platesGroupedByPlateGroup.forEach(plate => {

				const {
					CDFILAUXPRAT,
					CDPRATO
				} = plate
				const plateKey = CDFILAUXPRAT + CDPRATO
				const previousPlateInfo = platesInGroup[plateKey] || {}
				const currentMonth = plate.DTMESCARD
				const platePU = parseFloat(plate.PU_PRATO)
				const currentPUAverage = previousPlateInfo.mediaPU || 0

				let monthsUsedInAverage = previousPlateInfo.monthsUsedInAverage || 0
				let averagePU = currentPUAverage

				if (currentMonth !== lastMonth) {
					averagePU = _weightedAverage(currentPUAverage, monthsUsedInAverage, platePU)
					monthsUsedInAverage = monthsUsedInAverage + 1
				}
				platesInGroup[plateKey] = {
					...previousPlateInfo,
					ID: plateKey,
					pivo: plateKey,
					NM: plate.NMPRATO,
					NRGRUPOPRATOSERV: plate.NRGRUPOPRATOSERV,
					COD_TIP_PRATO: plate.CDTIPOPRAT,
					["qtde" + currentMonth]: plate.QTDE_PRATO,
					["cons" + currentMonth]: plate.CONSUMO_PRATO,
					["pu" + currentMonth]: platePU,
					mediaPU: averagePU,
					monthsUsedInAverage
				}

				groupData["qtde" + currentMonth] = plate.QTDE_GPPRATO
				groupData["cons" + currentMonth] = plate.CONSUMO_GPPRATO
				groupData["pu" + currentMonth] = parseFloat(plate.PU_GPPRATO)


				plateTypeData["qtde" + currentMonth] = plate.QTDE_TPPRAT
				plateTypeData["cons" + currentMonth] = plate.CONSUMO_TPPRAT
				plateTypeData["pu" + currentMonth] = parseFloat(plate.PU_TPPRAT)

			})

			return {
				...groupData,
				mediaPU: _getPUAverageFromObject(groupData, `pu${lastMonth}`),
				plateList: Object.values(platesInGroup)
			}
		})
		return {
			...plateTypeData,
			mediaPU: _getPUAverageFromObject(plateTypeData, `pu${lastMonth}`),
			gplist
		}
	})

	//console.log(incidenciasGroupedByPlate, `took ${performance.now() - begining}`)

	dataFromOtm.incidencia = {
		"incidenciaTabela": incidenciasGroupedByPlate,
		"meses": Object.keys(meses),
	}
	return dataFromOtm
}
const _getPlateTypeObjectFromPlate = function (plate, colInfo) {
	const plateKey = plate.unidadePrato + plate.prato

	const plateList = [{
		ID: plateKey,
		pivo: plateKey,
		NM: plate.nomePrato,
		comenDIV: plate.comenDIV,
		comensais: plate.comensais,
		NRGRUPOPRATOSERV: plate.gpprato
	}]

	const gplist = [{
		COD_TIP_PRATO: plate.COD_TIP_PRATO,
		pivo: plate.COD_GRP_TIP_PRATO,
		NM: plate.NOME_GRP_TIP_PRATO,
		plateList
	}]

	const plateTypeName = colInfo.find((col) => {
		return col.sequencial == plate.sequencial
	}).name

	const plateType = {
		NM: plateTypeName,
		ID: plate.COD_TIP_PRATO,
		pivo: plate.COD_TIP_PRATO,
		COD_TIP_PRATO: plate.COD_TIP_PRATO,
		isTPPRATO: true,
		gplist
	}

	return plateType
};

function buildDiasFromCatalog(dataCatalog) {
	const { tabela, pratos: pratosMap = {}, grupos: gruposMap = {}, colunas: colunasMap = {} } = dataCatalog;
	if (!Array.isArray(tabela)) return [];
  
	const comensaisDIVTotal = tabela.reduce(
	  (acc, d) => acc + (parseFloat(d.comensais_detalhe?.comensais_divisao) || 0), 0
	);
  
	return tabela.map(dia => ({
	  dia:       dia.data,
	  comenDIV:  parseFloat(dia.comensais_detalhe?.comensais_divisao) || 0,
	  comensais: parseFloat(dia.qtde_comensais) || 0,
	  pratos: (dia.colunas || [])
		.filter(col => col.id_prato)
		.map(col => {
		  const pratoInfo  = pratosMap[col.id_prato] || {};
		  const grupoInfo  = gruposMap[pratoInfo.id_grupo] || {};
		  const comensaisDia   = parseFloat(dia.qtde_comensais) || 0;
		  const percConsumo    = parseFloat(col.perc_consumo) || 0;
		  const vlrCusto       = parseFloat(pratoInfo.vlr_prato) || 0;
		  const custoPerCapita = comensaisDIVTotal > 0
			? ((comensaisDia * percConsumo / 100) * vlrCusto) / comensaisDIVTotal
			: 0;
  
		  return {
			prato:              col.id_prato,
			codprato:           col.id_prato,
			COD_TIP_PRATO:      String(col.id_coluna),
			sequencial:         String(col.id_coluna),
			percentualConsumo:  percConsumo,
			custoPerCapita,
			VLR_CUSTO_PRATO:    vlrCusto,
			nomePrato:          pratoInfo.nm_prato || '',
			gpprato:            pratoInfo.id_grupo,
			gppratoNome:        grupoInfo.nm_grupo || '',
			unidadePrato:       '',
			COD_GRP_TIP_PRATO:  grupoInfo.id_agrupamento_grupo,
			NOME_GRP_TIP_PRATO: grupoInfo.nm_agrupamento_grupo || '',
		  };
		}),
	}));
  }
  
  function buildColInfoFromCatalog(dataCatalog) {
	return Object.entries(dataCatalog?.colunas || {}).map(([id, col]) => ({
	  sequencial: id,
	  name: col.nm_tipoprato || ''
	}));
  }
  
  function getPuAcumlFromCatalog(dataCatalog) {
	const lastDay = [...(dataCatalog?.tabela || [])].reverse().find(d => d.qtde_comensais > 0);
	return lastDay?.vr_pu_acumulado ?? 0;
  };

let generateCompExcell = function (dias, incidencia, colInfo, puAcuml) {
	let allplates = [];
	let comensaisDIVTotal = 0;
	let consumoTotal = {};
	dias.forEach((d) => {
		comensaisDIVTotal += parseFloat(d.comenDIV);
		const dayKey = d.dia;
		consumoTotal[dayKey] = consumoTotal[dayKey] ? consumoTotal[dayKey] : {};
		(d.pratos || []).forEach(function (p) {
			if (p.prato) {
				consumoTotal[d.dia][p.COD_TIP_PRATO] = consumoTotal[d.dia][p.COD_TIP_PRATO] || 0;
				consumoTotal[d.dia][p.COD_TIP_PRATO] += parseFloat(p.percentualConsumo);
				let prato = JSON.parse(JSON.stringify(p));
				prato.comenDIV = parseFloat(d.comenDIV);
				prato.comensais = parseFloat(d.comensais);
				allplates.push(prato);
			}
		});
	});

	let contIncidenciaTipoPrato = {}
	let mediaIncidenciaTipoPrato = {}

	Object.entries(consumoTotal).forEach(([dia, tiposDePrato]) => {
		Object.entries(tiposDePrato).forEach(([tipoDePrato, consumo]) => {
			mediaIncidenciaTipoPrato[tipoDePrato] = mediaIncidenciaTipoPrato[tipoDePrato] || 0;
			mediaIncidenciaTipoPrato[tipoDePrato] += parseFloat(consumo);

			contIncidenciaTipoPrato[tipoDePrato] = contIncidenciaTipoPrato[tipoDePrato] ?
				contIncidenciaTipoPrato[tipoDePrato] + 1 : 1;

		})
	});


	let incListCopy = Object.assign({}, incidencia);
	let incidenciaTabela = null;
	let meses = null;

	incidenciaTabela = incListCopy.incidenciaTabela;
	meses = incListCopy.meses;
	const monthToRenderPUAverage = [...meses]
	const lastMonth = monthToRenderPUAverage.pop()

	let label = [{
			header: t('code_column'),
			key: "ID"
		},
		{
			header: t('name_column_group'),
			key: "NM"
		},
	];

	meses.forEach(m => {
		label.push({
			header: t('QTDE') + m,
			key: 'qtde' + m
		});
	});

	label.push({
		header: t('QTDE_OTM'),
		key: 'qtdeotm'
	});

	meses.forEach(m => {
		label.push({
			header: t('CONS') + m,
			key: 'cons' + m
		});
	});

	label.push({
		header: t('CONS_OTM'),
		key: 'consotm'
	});

	monthToRenderPUAverage.forEach(m => {
		label.push({
			header: "PU " + m,
			key: 'pu' + m
		});
	});

	label.push({
		header: t('medium_PU'),
		key: 'mediaPU'
	});

	label.push({
		header: t('PU_OTM'),
		key: 'puotm'
	});

	label.push({
		header: t('PU_OTM_medium_PU'),
		key: 'puotmmediapu'
	});

	label.push({
		header: "PU " + lastMonth,
		key: "pu" + lastMonth
	});

	label.push({
		header: "PU OTM - PU " + meses[meses.length - 1],
		key: 'puotmmescorrente'
	});

	allplates.forEach(p => {
		let tpprat = incidenciaTabela.find(it => p.COD_TIP_PRATO == it.pivo);
		if (!tpprat) {
			tpprat = _getPlateTypeObjectFromPlate(p, colInfo)
			incidenciaTabela.push(tpprat)
		}
		if (tpprat) {
			let inctpprat = allplates.filter(it => p.COD_TIP_PRATO == it.COD_TIP_PRATO);
			tpprat.qtdeotm = tpprat.qtdeotm ? tpprat.qtdeotm + 1 : 1;
			tpprat.consotm = 0;
			tpprat.puotm = 0;

			inctpprat.forEach(ap => {
				tpprat.consotm += parseFloat(ap.percentualConsumo);
				tpprat.puotm += parseFloat(ap.custoPerCapita);
			});

			tpprat.consotm = tpprat.consotm / inctpprat.length;
			tpprat.puotm = tpprat.puotm / inctpprat.length;

			let agpmen = tpprat.gplist.find(gplistItem => p.gpprato == gplistItem.pivo && p.COD_TIP_PRATO == gplistItem.COD_TIP_PRATO);
			if (agpmen) {
				let incagpmen = allplates.filter(ap => p.gpprato == ap.gpprato && p.COD_TIP_PRATO == ap.COD_TIP_PRATO);
				agpmen.qtdeotm = agpmen.qtdeotm ? agpmen.qtdeotm + 1 : 1;
				agpmen.consotm = 0;
				agpmen.puotm = 0;

				incagpmen.forEach(ap => {
					agpmen.consotm += parseFloat(ap.percentualConsumo);
					agpmen.puotm += parseFloat(ap.custoPerCapita);
				});

				agpmen.consotm = agpmen.consotm / incagpmen.length;
				agpmen.puotm = agpmen.puotm / incagpmen.length;

			} else {
				let newGpListItem = {
					//ID: p.gpprato,
					NM: p.gppratoNome,
					pivo: p.gpprato,
					COD_TIP_PRATO: p.COD_TIP_PRATO,
					qtdeotm: 1,
					consotm: parseFloat(p.percentualConsumo),
					puotm: parseFloat(p.custoPerCapita),
				};
				tpprat.gplist.push(newGpListItem);
				agpmen = tpprat.gplist.find(gplistItem => p.gpprato == gplistItem.pivo && p.COD_TIP_PRATO == gplistItem.COD_TIP_PRATO);
			}

			agpmen.plateList = agpmen.plateList || [];

			if (agpmen.pivo == p.gpprato) {
				let ptData = agpmen.plateList.find(ptListItem => ptListItem.pivo == p.codprato);
				if (!ptData) {
					agpmen.plateList.push({
						ID: `${p.codprato}`,
						NM: p.nomePrato,
						pivo: `${p.codprato}`,
						COD_TIP_PRATO: p.COD_TIP_PRATO,
						NRGRUPOPRATOSERV: p.gpprato,
					});
					ptData = agpmen.plateList.find(ptListItem => ptListItem.pivo == p.codprato);
				}
				let prato = ptData;

				let incpts = allplates.filter(ap => p.gpprato == ap.gpprato && p.COD_TIP_PRATO == ap.COD_TIP_PRATO && prato.pivo == ap.codprato);

				prato.qtdeotm = prato.qtdeotm ? prato.qtdeotm + 1 : 1;
				prato.consotm = 0;
				prato.puotm = 0;

				incpts.forEach(ap => {
					prato.consotm += parseFloat(ap.percentualConsumo);
					const VLR_CUSTO_PRATO = parseFloat(ap.VLR_CUSTO_PRATO)
					const percentualConsumo = ap.percentualConsumo
					const comensaisDia = ap.comensais
					const puotm = (percentualConsumo / 100 * comensaisDia) * VLR_CUSTO_PRATO

					prato.puotm += puotm
				});

				prato.consotm = prato.consotm / incpts.length;
				prato.puotm = prato.puotm / comensaisDIVTotal;
			}

		} 
	});
	let data = [];
	
	incidenciaTabela.forEach((i, index) => {
		let incCopy = JSON.parse(JSON.stringify(i));
		delete incCopy.gplist;

		incCopy.style = {
			'font': {
				'bold': true
			},
			fill: {
				type: 'pattern',
				pattern: 'solid',
				fgColor: {
					argb: 'FFa6a6a6'
				}
			},
			numFmt: "0.00000"
		};
		const incCopyMediaPU = parseFloat(incCopy.mediaPU)
		incCopy.cons = parseFloat(incCopy.cons) || null;
		incCopy.consotm = incCopy.consotm && parseFloat(incCopy.consotm) || null;
		incCopy.pu = parseFloat(incCopy.pu) || null;
		incCopy.mediaPU = incCopyMediaPU && incCopyMediaPU || null;
		incCopy.puotm = incCopy.puotm && parseFloat(incCopy.puotm) || null;

		let gpList = i.gplist || [];
		let gpFinalList = [];
		gpList.forEach(igp => {
			const igpMediaPU = parseFloat(igp.mediaPU)
			igp.cons = parseFloat(igp.cons) || null;
			// igp.consotm = igp.consotm && parseFloat(igp.consotm) || null;
			igp.pu = parseFloat(igp.pu) || null;
			igp.mediaPU = igpMediaPU && igpMediaPU || null;
			igp.puotm = igp.puotm && parseFloat(igp.puotm) || null;
			igp.style = {
				fill: {
					type: 'pattern',
					pattern: 'solid',
					fgColor: {
						argb: 'FFbfbfbf'
					}
				},
				numFmt: "0.00000"
			}

			gpFinalList.push(igp);

			let plateList = igp.plateList || [];
			let consotmSum = 0,
				plateCount = 0
			// let puotmAcc = 0
			plateList.forEach(ipl => {
				const iplMediaPU = parseFloat(ipl.mediaPU)
				ipl.cons = parseFloat(ipl.cons) || null;
				ipl.consotm = ipl.consotm && parseFloat(ipl.consotm) || null;
				ipl.pu = ipl.pu && parseFloat(ipl.pu) || null;
				ipl.mediaPU = iplMediaPU && iplMediaPU || null;
				ipl.puotm = ipl.puotm && parseFloat(ipl.puotm) || null;
				ipl.puotmmediapu = (ipl.puotm && ipl.mediaPU) ? parseFloat(ipl.puotm) - parseFloat(ipl.mediaPU) : ipl.puotm || parseFloat(ipl.mediaPU) * -1;
				ipl.puotmmediapu = ipl.puotmmediapu ? parseFloat(ipl.puotmmediapu) : null;
				ipl.puotmmescorrente = (ipl.puotm && ipl['pu' + meses[meses.length - 1]]) ? parseFloat(ipl.puotm) - parseFloat(ipl['pu' + meses[meses.length - 1]]) : ipl.puotm || parseFloat(ipl['pu' + meses[meses.length - 1]]) * -1;
				ipl.puotmmescorrente = ipl.puotmmescorrente ? parseFloat(ipl.puotmmescorrente) : null;
				ipl.style = {
					numFmt: "0.00000"
				}

				gpFinalList.push(ipl);

				if (ipl.consotm !== null) {
					consotmSum += parseFloat(ipl.consotm)
					plateCount++
				}
			});

			const groupConsotm = consotmSum / plateCount
			const puotmPlateSum = plateList.reduce((accumulator, plate) => {
				const sumSubject = plate.puotm || 0
				accumulator += sumSubject
				return accumulator
			}, 0)
			igp.consotm = groupConsotm || null;
			igp.puotm = puotmPlateSum || null;
			igp.puotmmediapu = (igp.puotm && igp.mediaPU) ? parseFloat(igp.puotm) - parseFloat(igp.mediaPU) : igp.puotm || parseFloat(igp.mediaPU) * -1;
			igp.puotmmediapu = igp.puotmmediapu ? parseFloat(igp.puotmmediapu) : null;
			igp.puotmmescorrente = (igp.puotm && igp['pu' + meses[meses.length - 1]]) ? parseFloat(igp.puotm) - parseFloat(igp['pu' + meses[meses.length - 1]]) : igp.puotm || parseFloat(igp['pu' + meses[meses.length - 1]]) * -1;
			igp.puotmmescorrente = igp.puotmmescorrente ? parseFloat(igp.puotmmescorrente) : null;

		});

		const puotmGroupSum = gpList.reduce((accumulator, plateGroup) => {
			const sumSubject = plateGroup.puotm || 0
			accumulator += sumSubject
			return accumulator
		}, 0);
		incCopy.puotm = puotmGroupSum || null;
		incCopy.puotmmediapu = (incCopy.puotm && incCopy.mediaPU) ? parseFloat(incCopy.puotm) - parseFloat(incCopy.mediaPU) : incCopy.puotm || parseFloat(incCopy.mediaPU) * -1;
		incCopy.puotmmediapu = incCopy.puotmmediapu ? parseFloat(incCopy.puotmmediapu) : null;
		incCopy.puotmmescorrente = (incCopy.puotm && incCopy['pu' + meses[meses.length - 1]]) ? parseFloat(incCopy.puotm) - parseFloat(incCopy['pu' + meses[meses.length - 1]]) : incCopy.puotm || parseFloat(incCopy['pu' + meses[meses.length - 1]]) * -1;
		incCopy.puotmmescorrente = incCopy.puotmmescorrente ? parseFloat(incCopy.puotmmescorrente) : null;

		if (mediaIncidenciaTipoPrato[incCopy.COD_TIP_PRATO]) {
			let incidencias = contIncidenciaTipoPrato[incCopy.COD_TIP_PRATO];
			let total = mediaIncidenciaTipoPrato[incCopy.COD_TIP_PRATO];
			incCopy.consotm = total / incidencias;
		} else {
			incCopy.consotm = null;
		}


		if (index === 0) {
			// copia o esqueleto do objeto e deixa todos os valores nulos
			const emptyLine = { ...incCopy };
			Object.keys(emptyLine).forEach((key) => {
				emptyLine[key] = null;
			});
		
			const puSumsByDate = {};
			let totalMediaPU = 0;
		
			incidenciaTabela.forEach((item) => {
				totalMediaPU += parseFloat(item.mediaPU) || 0; // acumulando mediaPU
		
				Object.keys(item).forEach((key) => {
					if (key.startsWith("pu") && key !== "puotm" && key !== "pu") {
						const date = key.slice(2); // remove o "pu" do início da chave
		
						// inicializa a soma para a data se ainda não existir
						if (!puSumsByDate[date]) {
							puSumsByDate[date] = 0;
						}
		
						puSumsByDate[date] += parseFloat(item[key]) || 0;
					}
				});
			});
		
			Object.keys(puSumsByDate).forEach((date) => {
				const keyName = `pu${date}`; // formar a chave completa novamente
				emptyLine[keyName] = parseFloat(puSumsByDate[date]);
			});
		
			emptyLine.mediaPU = parseFloat(totalMediaPU); 
			emptyLine.puotm = parseFloat(puAcuml); 
			emptyLine.puotmmediapu = parseFloat(puAcuml - totalMediaPU); 
		
			const lastMonthKey = `pu${meses[meses.length - 1]}`;
			emptyLine.puotmmescorrente = parseFloat(emptyLine.puotm) - parseFloat(emptyLine[lastMonthKey] || 0);
		
			emptyLine.NM = t('TOTALIZADOR_DO_SERVIÇO');
			emptyLine.style = {
				font: {
					bold: true
				},
				fill: {
					type: 'pattern',
					pattern: 'solid',
					fgColor: {
						argb: 'FFEAF7FD'
					}
				},
				numFmt: "0.00000"
			};
		
			data.push(emptyLine);
		}

		data.push(incCopy);
		data = data.concat(gpFinalList);
		// data.push([]);
		let dashes = [];
		label.forEach(l => {
			dashes.push('--');
		});
		data.push(dashes);
		// data.push([]);
	});
	incidenciaTabela = null;
	meses = null;
	return {
		label,
		data
	};
};

let generatelogBuracosExcel = function (datas) {

	let label = [
		{
			header: t('dish_type'),
			key: "TP"
		},
		{
			header: t('group_of_dishes'),
			key: "GP"
		},
		{
			header: t('frequency_minimum_month'),
			key: 'freqMin'
		},
		{
			header: t('frequency_max_month'),
			key: 'freqMax'
		},
		{
			header: t('frequency_max_week'),
			key: 'freqMaxSem'
		},
		{
			header: t('number_used'),
			key: 'utilizado'
		},
		{
			header: t('number_used_week'),
			key: 'utilizadoSemana'
		},
		{
			header: '',
			key: 'warning'
		}
	];
	
	const newArrExcel = [];
      datas.forEach((data) => {
		const dateRow = data.dia;
		newArrExcel.push({'TP': 'Dia ' + dateRow, 'GP': '', 'freqMin': '', 'freqMax': '', 'freqMaxSem': '', 'utilizado': '', 'utilizadoSemana': ''});

        data.logBuracos && data.logBuracos.seqFaltantes.forEach((prato) => {
          const nmPrato = prato.nometipoprato;
		  let freqCont = 0;
		  newArrExcel.push({'TP': nmPrato, 'GP': '', 'freqMin': '', 'freqMax': '', 'freqMaxSem': '', 'utilizado': '', 'utilizadoSemana': ''});
		
		  prato.NUM_GRP_PRATO.forEach((grpPrato) => {
            const freq = data.logBuracos && data.logBuracos.frequencias.find(element => element.NUM_GRP_PRATO == grpPrato);
            if(freq != undefined) {
			  freqCont = freqCont+1;
              const momentDateRow = moment(dateRow, "DD/MM/YYYY");
              if(momentDateRow.format('dddd') == 'Sunday') momentDateRow.add('d', 1);
              const numberWeek = momentDateRow.format('WW');

			  let numberUsage = freq.curWeekUsage && freq.curWeekUsage[numberWeek] || 0;
			  numberUsage = numberUsage.toString();
			  if (numberUsage == freq.MAX_SEM_GRP) {
				numberUsage = numberUsage + ' *';
			  }

			  freq.cur = freq.cur || 0;
			  freq.cur = freq.cur.toString();
			  if(freq.cur == freq.MAX_MES_GRP) {
				freq.cur = freq.cur + ' *';
			  }
			  
			  newArrExcel.push({
					'TP': '',
					'GP': freq.NOME_GRUPO,
				  'freqMin': freq.MIN_MES_GRP, 
				  'freqMax': freq.MAX_MES_GRP, 
				  'freqMaxSem': freq.MAX_SEM_GRP, 
				  'utilizado': freq.cur || 0, 
				  'utilizadoSemana': numberUsage
				});
            }
		  });
		  
		  // Se o tipo de prato nao possui frequencias ele e removido
		  if(freqCont == 0) newArrExcel.pop();
		}); 
		
		if(newArrExcel[newArrExcel.length - 1].TP.indexOf('Dia') != -1) {
			// Se o unico dado do conjunto for a data ela e removida
			newArrExcel.pop();
		} else {
			// Adicionar espaco no final de cada conjunto no excel
			let dashes = [];
			label.forEach(l => {
				dashes.push('--');
			});
			newArrExcel.push(dashes);
		}
	});
		newArrExcel.push({
			'TP': '', 'GP': '','freqMin': '', 'freqMax': '', 'freqMaxSem': '', 'utilizado': '', 'utilizadoSemana': '', 'warning': t('group_already_reached_for_week_or_for_month')
		});
		newArrExcel.push({
			'TP': '', 'GP': '','freqMin': '', 'freqMax': '', 'freqMaxSem': '', 'utilizado': '', 'utilizadoSemana': '', 'warning': t('suggested_action_check_the_month_week_maximum_frequency_amount')
		});
		newArrExcel.push({
			'TP': '', 'GP': '','freqMin': '', 'freqMax': '', 'freqMaxSem': '', 'utilizado': '', 'utilizadoSemana': '', 'warning': t('suggested_action_check_group_repeats_on_weekdays')
		});

	return {
		label,
		newArrExcel
	};
};

function fixIdPrato(dataCatalog, cdfilial) {
	if (!dataCatalog?.tabela || !dataCatalog?.pratos) return;

	const tabela = dataCatalog.tabela;
	const pratos = dataCatalog.pratos;
	const filialPrefix = String(cdfilial);

	for (let i = 0, tLen = tabela.length; i < tLen; i++) {
		const dia = tabela[i].colunas;
		if (!dia) continue;

		for (let j = 0, dLen = dia.length; j < dLen; j++) {
			const coluna = dia[j];
			if (!coluna) continue;

			let id = coluna.id_prato;
			if (!id || pratos[id]) continue;

			// evita concat se já começa com P
			if (id[0] !== 'P') {
				const idP = 'P' + id;
				if (pratos[idP]) {
					coluna.id_prato = idP;
					continue;
				}
			}

			// evita concat se já tem prefixo da filial
			if (!id.startsWith(filialPrefix)) {
				const idFilial = filialPrefix + id;
				if (pratos[idFilial]) {
					coluna.id_prato = idFilial;
				}
			}
		}
	}
};

const serviceInstance = {
	addIncidencia_tp_gp_prato,
	generateCardExcell,
	generateCompExcell,
	generatelogBuracosExcel,
	feedINGData,
	buildDrilldown,
	computeChartData,
	fixIdPrato,
	buildDiasFromCatalog,
	buildColInfoFromCatalog,
	getPuAcumlFromCatalog,
};

export default serviceInstance;
